import tictactoe from "./GamesImages/tictactoe.png";
import cogni from './GamesImages/cognishine-logo.png'
import memory from './GamesImages/memory.png'

export const gamesData = [
  { url: "https://p.interacty.me/51495a343e7cd0c4/iframe.html", title: "משחק הזכרון", id: "1", img: memory },

  {
    url: "https://codepen.io/martingordon13/embed/bGjXyBv?default-tab=result",
    title: "איקס עיגול",
    id: "2",
    img: tictactoe,
  },
  {
    url: "https://cognishine.com/he-il",
    title: "Cognishine",
    id: "3",
    img: cogni,
  },
];


